/**
 * Created by renjie.huang on 2017/12/5.
 */

var route = {
    path : '/retrieveInput',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/RetrieveInput.js').default)
        }, 'retrieve-input')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/retrieveInput.js